export enum InvoiceStatus {
  TRIAL = 'trial',
  TRIAL_PAID = 'trial_paid',
  TRIAL_OVERDUE = 'trial_overdue',
  PAID = 'paid',
  OVERDUE = 'overdue',
}
